module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Expedition Fairbanks","short_name":"Alaskaclave","start_url":"/","background_color":"#061A4A","theme_color":"#FFB70A","display":"standalone","icon":"static/images/logoYellow.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"c490cb0abb2f68b6afac018e741e4656"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
